import React, { useEffect, useState } from "react";
import moment from "moment";
import ModalComponent from "../../../../components/modals/ModalComponent";
import SkeletonTable from "../../../../components/table/SkeletonTable";
import columns from "../../../../columns/reports/auditReport";
import { GetAuditReportApi } from "../../../../api/request/reports/report";

const AuditModal = ({ organizer, isOpen, setIsOpen }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getAuditReportData = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetAuditReportApi({ organizer_id: organizer?.id });
      if (data?.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              organizerName: item?.client?.name,
              taskName: item?.task?.name,
              employeeName: item?.assigned_employee?.name,
              status: (
                <p
                  className={`font-bold uppercase ${
                    item?.status === "completed"
                      ? "text-green-500"
                      : "text-gray-500"
                  }`}
                >
                  {item?.status}
                </p>
              ),
              startDate: item?.auto_start_date
                ? moment(item?.auto_start_date).format("lll")
                : "",
              completedDate: item?.complated_date
                ? moment(item?.complated_date).format("lll")
                : "",
            };
          })
        );
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (organizer?.id) getAuditReportData();
  }, [organizer]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={`Audit Report (${organizer?.organizer_name_slug})`}
      width={1000}
    >
      <SkeletonTable columns={columns} data={data} isLoading={isLoading} />
    </ModalComponent>
  );
};

export default AuditModal;
